import axios from 'axios'
import { backendUrl } from '../../config/config'

const getWorklist = async () => {
  const worklist = await axios.get(`${backendUrl}/api/worklist/`)
  return worklist.data
}

const getWorklistByQuery = async (query) => {
  const worklist = await axios.post(`${backendUrl}/api/worklist/`, query)
  return worklist.data
}

const getWorklistById = async (uuid) => {
  const worklist = await axios.get(`${backendUrl}/api/worklist/${uuid}`)
  return worklist.data
}

const exportJSON = async (uuid) => {
  const exportString = await axios.get(`${backendUrl}/api/worklist/${uuid}/export`)
  return exportString.data
}

const exportCSV = async (uuid) => {
  const exportString = await axios.get(`${backendUrl}/api/worklist/${uuid}/exportCSV`)
  return exportString.data
}

const deleteWorklist = async (uuid) => {
  const result = await axios.delete(`${backendUrl}/api/worklist/deleteWorklist/${uuid}`)
  return result
}

const getStatuses  = async () => {
  const result = await axios.get(`${backendUrl}/api/worklist/getStatuses`)
  return result.data
}

const getPayments  = async () => {
  const result = await axios.get(`${backendUrl}/api/worklist/getPayments`)
  return result.data
}

const getNegoLogics  = async () => {
  const result = await axios.get(`${backendUrl}/api/worklist/getNegoLogics`)
  return result.data
}

const getTeams  = async () => {
  const result = await axios.get(`${backendUrl}/api/worklist/getTeams`)
  return result.data
}


const getFeedbacks = async (query) => {
  const worklist = await axios.post(`${backendUrl}/api/worklist/feedbacks`, query)
  return worklist.data
}

 export {
   getWorklist,
   getWorklistById,
   exportJSON,
   exportCSV,
   getWorklistByQuery,
   deleteWorklist,
   getStatuses,
   getPayments,
   getNegoLogics,
   getTeams,
   getFeedbacks
 }